import { render, staticRenderFns } from "./modal_composition_by_type_publication_book.vue?vue&type=template&id=33de556f"
import script from "./modal_composition_by_type_publication_book.vue?vue&type=script&lang=js"
export * from "./modal_composition_by_type_publication_book.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports